import get from "lodash/get";

class Loyalty {
  constructor(obj) {
    this.obj = obj;
  }

  get points() {
    return parseInt(get(this.obj, "attributes.points.points", "0") || "0");
  }

  get tierPoints() {
    const points = get(this.obj, "attributes.tier.points.amount", 0) || 0;
    return (points / 100).toFixed(0);
  }

  get announcement() {
    return get(this.obj, "attributes.tier.announcement", null);
  }

  get rank() {
    return get(this.obj, "attributes.tier.rank", -1);
  }
}

export default Loyalty;
